export type UserRole = 'ADMIN' | 'CRM' | 'DEFAULT';

export const userRoles: { label: string; value: UserRole }[] = [
  { label: 'User', value: 'DEFAULT' },
  { label: 'Crm', value: 'CRM' },
  { label: 'Admin', value: 'ADMIN' },
];

/**
 * A backoffice operator, as stored by ASP.NET Identity.
 * Distinct from `BusinessOwner` — the two used to share a single `User` type.
 */
export interface AdminUser {
  id: string;
  email: string;
  userName: string;
  phoneNumber?: string;
  emailConfirmed: boolean;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  lockoutEnd: Date | null;
  lockoutEnabled: boolean;
  accessFailedCount: number;
  role: UserRole;
}
